import React from "react";
import { DollarSign, PieChartIcon, TrendingUp, Target, Coins, Banknote, BarChart3, PiggyBank } from "lucide-react";

// Income Statement KPIs for 2024 based on the extended income statement
const incomeStatementKPIs = [
  {
    title: "Total Revenue",
    value: "$2,600,000",
    change: "↑ 18% from last year",
    icon: <DollarSign className="h-6 w-6 text-green-500" />,
    textColor: "text-green-600",
  },
  {
    title: "Total Expenses (COGS + Operating)",
    value: "$1,910,000",
    change: "↑ 15% from last year",
    icon: <PieChartIcon className="h-6 w-6 text-red-500" />,
    textColor: "text-red-600",
  },
  {
    title: "Gross Profit",
    value: "$1,560,000",
    change: "↑ 18.2% from last year",
    icon: <BarChart3 className="h-6 w-6 text-blue-500" />,
    textColor: "text-blue-600",
  },
  {
    title: "EBITDA",
    value: "$690,000",
    change: "↑ 21% from last year",
    icon: <Target className="h-6 w-6 text-purple-500" />,
    textColor: "text-purple-600",
  },
  {
    title: "Operating Income (EBIT)",
    value: "$580,000",
    change: "↑ 20% from last year",
    icon: <Coins className="h-6 w-6 text-orange-500" />,
    textColor: "text-orange-600",
  },
  {
    title: "Interest Expense",
    value: "$30,000",
    change: "↑ 5% from last year",
    icon: <Banknote className="h-6 w-6 text-yellow-500" />,
    textColor: "text-yellow-600",
  },
  {
    title: "Pre-Tax Income",
    value: "$575,000",
    change: "↑ 19% from last year",
    icon: <BarChart3 className="h-6 w-6 text-teal-500" />,
    textColor: "text-teal-600",
  },
  {
    title: "Income Tax Expense",
    value: "$138,000",
    change: "↑ 6% from last year",
    icon: <Banknote className="h-6 w-6 text-red-400" />,
    textColor: "text-red-500",
  },
  {
    title: "Net Income",
    value: "$437,000",
    change: "↑ 22% from last year",
    icon: <TrendingUp className="h-6 w-6 text-indigo-500" />,
    textColor: "text-indigo-600",
  },
  {
    title: "Dividends Paid",
    value: "$70,000",
    change: "↑ 4.5% from last year",
    icon: <PiggyBank className="h-6 w-6 text-pink-500" />,
    textColor: "text-pink-600",
  },
  {
    title: "Retained Earnings",
    value: "$367,000",
    change: "↑ 23% from last year",
    icon: <Target className="h-6 w-6 text-green-500" />,
    textColor: "text-green-600",
  },
];

// Income Statement KPIs Component
const IncomeStatementKPIs = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6 mb-8">
      {/* Header */}
      <div className="flex items-center space-x-2 mb-6">
        <BarChart3 className="h-6 w-6 text-blue-600" />
        <h3 className="text-lg font-medium text-gray-900">Income Statement KPIs (2024)</h3>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {incomeStatementKPIs.map((metric, index) => (
          <div key={index} className="bg-white rounded-lg shadow p-6 hover:scale-105 transition-transform">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-medium text-gray-900">{metric.title}</h3>
              {metric.icon}
            </div>
            <p className="mt-3 text-2xl font-semibold text-gray-900">{metric.value}</p>
            <p className={`text-sm mt-1 ${metric.textColor}`}>{metric.change}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IncomeStatementKPIs;
